import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import FindGoMill from "./pages/FindGoMill";
import BookEvent from "./pages/BookEvent";
import About from "./pages/About";
import Franchise from "./pages/Franchise";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdminPanel from "./pages/AdminPanel";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function HideEmergentBadge() {
  useEffect(() => {
    const hide = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.style.setProperty("display", "none", "important");
    };
    hide();
    const obs = new MutationObserver(hide);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) {
    return (
      <>
        <Routes>
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#111",
              color: "#FAF9F6",
              border: "1px solid #C9A24B",
              borderRadius: "12px",
              fontFamily: "Inter, sans-serif",
            },
          }}
        />
      </>
    );
  }
  return (
    <div className="min-h-screen flex flex-col bg-gomill-bg">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/find" element={<FindGoMill />} />
          <Route path="/book-event" element={<BookEvent />} />
          <Route path="/about" element={<About />} />
          <Route path="/franchise" element={<Franchise />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0F3824",
            color: "#FAF9F6",
            border: "1px solid #2D5A3F",
            borderRadius: "16px",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <HideEmergentBadge />
      <Shell />
    </BrowserRouter>
  );
}

export default App;
